<template>
    <section class="gmp-section gmp-mb-l">
        <div class="two-column-tout">
            <div class="h-c-page">

                <div class="h-c-grid">
                    <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6
            h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                        <h3 class="h-c-headline h-c-headline--one">
                            了解具体特点
                        </h3>
                        <div class="h-u-mb-std two-column-tout__description">
                            <p class="">
                                通过结合客户的配送距离和订购数量，设计科学先进的功能模块
                            </p>
                        </div>
                        <a  @click="toEnterprisePage('/market/platform/PL_Special','/market/platform/PL_Special')"
                            class="h-c-link h-c-link--internal gmp-link">
                            查看详细
                        </a>
                    </div>

                    <div class="h-c-grid__col
          h-c-grid__col-l--6  h-c-grid__col--align-middle">
                        <div class="two-column-tout__image text-center">
                            <picture>
                                <img src="@/assets/img/right.png" alt="" class="gmp-no-grab ">
                            </picture>
                        </div>
                    </div>

                </div>
            </div>


        </div>

    </section>
</template>

<script>
    export default {
        name: "PL_twoTout",
        methods:{
            toLevelType(data){
                this.$router.push(data)
                this.isShowDrawer = false;
                this.$('body').removeClass('h-is-showing-drawer');

            },

            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }
    }
</script>

<style lang="less">


</style>
